<div class="row">
  <!-- <div class="col-sm-4 mb-3 col-md-6 col-lg-4 col-xl-3"> -->
  <div class="col-sm-4">
    <div class="card h-100">
      <div class="card-header">
        <h3 class="h5">Birthday</h3>
        <!-- <h2>Birthday</h2> -->
      </div>
      <div class="card-body image-content">
        <div class="container scrollable-container" style="max-height: 220px; overflow-y: auto; overflow-x: hidden;">
          <div *ngIf="notifications && notifications['birthday'] && notifications['birthday']?.length > 0 ">
            <span *ngFor="let item of notifications['birthday']" style="margin-left: 10px;margin-top: 10px;">

              <i class="ri-cake-2-fill"></i> {{item.employeeName}} Birthday on {{moment(item.date).format('DD')}}
              <br>
            </span>
          </div>
          <div
            *ngIf="notifications && notifications['marriageAnniversary'] && notifications['marriageAnniversary']?.length > 0 ">
            <span *ngFor="let item of notifications['marriageAnniversary']" style="margin-left: 10px;margin-top: 10px;">
              <i class="ri-cake-2-fill"></i> {{item.employeeName}} Marriage Anniversary on
              {{moment(item.date).format('DD')}}
              <br>
            </span>
          </div>

          <p class="text-center p-2" *ngIf="isNoBdayData">No birthday today</p>

        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-4 ">
    <div class="card h-100">
      <div class="card-header">
        <h3 class="h5">Work Anniversary</h3>
      </div>
      <div class="card-body image-content">
        <div class="container scrollable-container" style="max-height: 220px; overflow-y: auto; overflow-x: hidden;">
          <div class="">
            <div
              *ngIf="notifications && notifications['workAnniversary'] && notifications['workAnniversary']?.length > 0 ">
              <span *ngFor="let item of notifications['workAnniversary']" style="margin-left: 10px;margin-top: 10px;">
                <i class="ri-cake-2-fill"></i> {{item.employeeName}} Work Anniversary on
                {{moment(item.date).format('DD')}}
                <br>
              </span>
            </div>
            <div class="box">
              <p class="text-center p-2" *ngIf="isNoWorkAnniversaryData">No Work Anniversary</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-4 ">
    <div class="card h-100 dashboard-leave-counter">
      <div class="card-header">
        <h2>My Leave Status</h2>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="row grey-boxes">
            <div class="box">
              <p class="table-box-heading">Earned Leave</p>
              <i class="ri-calendar-check-line" style="color:purple"></i>
              <p class="text-left">Available: {{earnleave}}</p>
            </div>
            <div class="box">
              <p class="table-box-heading">Casual Leave</p>
              <i class="ri-calendar-check-line" style="color:purple"></i>
              <p class="text-left">Available: {{casualleave}}</p>
            </div>
            <div class="box">
              <p class="table-box-heading">Compoff</p>
              <i class="ri-calendar-check-line" style="color:green"></i>
              <p class="text-left">Available: {{compensatoryleave}}</p>
            </div>
          </div>
          <hr style="margin-left: 5px;margin-bottom: 5px; width: 98%;">
          <div>
            <span style="margin-left: 5px;font-weight: bold;margin-top: 10px;">Leave Notifications</span>
            <div *ngIf="leaveData.length > 0 ">
              <span *ngFor="let item of leaveData" style="margin-left: 10px;margin-top: 10px;">
                <i class="ri-file-list-3-line"></i> "{{item.applicationTitle}}" applied leave for
                {{moment(item.startDate).format('DD-MM-YYYY')}} is {{item.status}}.
                <br>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body d-none">
        <div class="box">
          <p>No upcoming today</p>
          <img src="assets/svg/upcomingEvent.svg" alt="">
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isManagerOrAdmin">
    <div class="col-sm-4 mt-3">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Pending Leave Approval</h3>
        </div>
        <div class="card-body image-content">
          <div class="container">
            <div *ngIf="isLoadingPendingLeaves" class="theme-loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <ng-container *ngIf="!isLoadingPendingLeaves">
              <div *ngIf="pendingLeaves && pendingLeaves.length > 0">
                <span *ngFor="let item of pendingLeaves" style="margin-left: 10px;margin-top: 10px; display: block;">
                  <i class="ri-calendar-event-line"></i> {{item.userIdUserName }} ({{item.applicationTitle}}) applied
                  for {{item.leavetype}} on
                  {{moment(item.startDate).format('DD-MMM')}}
                </span>
              </div>
              <p class="text-center p-2" *ngIf="!pendingLeaves || pendingLeaves.length === 0">No pending leave approvals
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4 mt-3">
      <div class="card h-100">
        <div class="card-header">
          <h3 class="h5">Pending Regularization Approval</h3>
        </div>
        <div class="card-body image-content">
          <div class="container">
            <div *ngIf="isLoadingPendingRegularizations" class="theme-loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <ng-container *ngIf="!isLoadingPendingRegularizations">
              <div *ngIf="pendingRegularizations && pendingRegularizations.length > 0">
                <span *ngFor="let item of pendingRegularizations"
                  style="margin-left: 10px;margin-top: 10px; display: block;">
                  <i class="ri-time-line"></i> {{item.employeeName}} applied for regularization on
                  {{moment(item.attendanceDate).format('DD-MMM')}}
                </span>
              </div>
              <p class="text-center p-2" *ngIf="!pendingRegularizations || pendingRegularizations.length === 0">No
                pending
                regularizations</p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4 mt-3">
      <div class="card h-100 dashboard-leave-counter">
        <div class="card-header">
          <h2>Count for other pending approvals</h2>
        </div>
        <div class="card-body">
          <div *ngIf="isLoadingApprovalCounts" class="theme-loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <div class="row flex-column" style="margin-left: 0;" *ngIf="!isLoadingApprovalCounts">
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Timesheet V1 Approvals : </span>
              <span style="margin-left: 5px;">{{this.timesheetV1Count}}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Timesheet V2 Approvals : </span>
              <span style="margin-left: 5px;">{{this.timesheetV2Count}}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Comp-off Approvals : </span>
              <span style="margin-left: 5px;">{{this.compOffCount}}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Overtime Approvals : </span>
              <span style="margin-left: 5px;">{{this.overtimeCount}}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Leave Approvals : </span>
              <span style="margin-left: 5px;">{{this.leaveCount}}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="margin-left: 5px;font-weight: bold;">Pending Regularization Approvals : </span>
              <span style="margin-left: 5px;">{{this.regularizationCount}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="col-sm-8 mt-3">
    <div class="card h-100">
      <div class="card-header">
        <h2>Calendar</h2>
      </div>
      <div class="card-body" style="padding: 2%;">
        <ejs-schedule #scheduleObj height="550px" [eventSettings]='eventSettings' [currentView]='currentView'>
          <e-views>
            <e-view option="Month" [showWeekend]="showWeekend"></e-view>
            <e-view option="Week"></e-view>
            <e-view option="Day"></e-view>
          </e-views>
        </ejs-schedule>
      </div>
    </div>
  </div>
  <!-- <div class="col-sm-4 mt-3">
    <div class="card h-100">
      <div class="card-header">
        <h2>Upcoming events</h2>
      </div>
      <div class="card-body">
        <div class="box">  
        </div>
      </div>
    </div>
  </div> -->
  <div class="col-sm-4 mt-3">
    <div class="card h-100">
      <div class="card-header">
        <h2>My Comp-Off Details</h2>
      </div>
      <div class="card-body">
        <div class="newBox scrollable-container" style="max-height: 220px; overflow-y: auto; overflow-x: hidden;">
          <div *ngIf="compOffNotifications?.length > 0 ">
            <span *ngFor="let item of compOffNotifications" style="margin-left: 10px;margin-top: 10px; display:block;">
              <i class="ri-calendar-check-line"></i> {{item.employeeName}} Comp-Off applied for {{item.applicationDate}}
              will be valid until {{item.validityDate}}.
              <br>
            </span>
          </div>
        </div>
        <div class="box">
          <p class="text-center p-2" *ngIf="isNoData">No Comp-off expiring in next 7 days.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<main class="main-dashboard d-none">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <h3>Dashboard</h3>
            </div>
            <div class="col-sm-6" style="
                display: flex;
                justify-content: flex-end;
                align-items: center;
              ">
              <div>
                <button type="button" class="btn btn-icon" (click)="onAdd()" *ngIf="dashboardIndexNum === 6">
                  <i class="ri-add-line"></i>
                </button>
              </div>
            </div>
          </div>
          <ejs-dashboardlayout id="predefine_dashboard" #predefine_dashboard columns="6" [panels]="panelsData"
            [cellSpacing]="cellSpacing" [allowResizing]="true">
          </ejs-dashboardlayout>
        </div>
      </section>
    </section>
  </article>
</main>

<!-- Floating Chatbot Widget -->
<div class="chatbot-container" *ngIf="isPragamanaTenant">
  <!-- The Chat Window -->
  <div class="chatbot-window" *ngIf="isChatbotOpen">
    <div class="chatbot-header">
      <h3 class="h5 m-0 text-white"><i class="ri-robot-line"></i> Pragamana Bot</h3>
      <button class="btn btn-sm text-white p-0" (click)="toggleChatbot()">
        <i class="ri-close-line" style="font-size: 20px;"></i>
      </button>
    </div>

    <div class="chatbot-messages">
      <div *ngFor="let msg of chatMessages" class="chat-message"
        [ngClass]="msg.sender === 'user' ? 'msg-user' : 'msg-bot'">
        <span>{{ msg.text }}</span>
      </div>
      <div *ngIf="isBotTyping" class="chat-message msg-bot">
        <span><i class="ri-more-fill typing-indicator"></i></span>
      </div>
    </div>

    <div class="chatbot-input">
      <input type="text" placeholder="Type your question..." [(ngModel)]="currentQuery" (keyup.enter)="sendMessage()" />
      <button class="btn btn-sm" (click)="sendMessage()" [disabled]="isBotTyping || !currentQuery.trim()">
        <i class="ri-send-plane-fill"></i>
      </button>
    </div>
  </div>

  <!-- The Floating Bubble Button -->
  <button class="chatbot-trigger-btn" (click)="toggleChatbot()" [ngClass]="{'active': isChatbotOpen}">
    <i class="ri-message-3-line" *ngIf="!isChatbotOpen"></i>
    <i class="ri-close-line" *ngIf="isChatbotOpen"></i>
  </button>
</div>